<template>
  <div class="auditDetail">
    <div id="ag-table" class="dataTables_wrapper dt-bootstrap4 no-footer">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{$t("id")}}</th>
              <th scope="col">{{$t("tableName")}}</th>
              <th scope="col">{{$t("columnName")}}</th>
              <th scope="col">{{$t("oldValue")}}</th>
              <th scope="col">{{$t("newValue")}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData.Changes" :key="index">
              <td>
                {{ tableData.PrimaryKey.Id }}
              </td>
              <td>
                {{ tableData.Table }}
              </td>
              <td>
                {{ item.ColumnName }}
              </td>
              <td>
                <span v-if="!chekcJson(item.OriginalValue)">{{
                  item.OriginalValue
                }}</span>
                <pre v-if="chekcJson(item.OriginalValue)">{{
                  chekcJson(item.OriginalValue)
                }}</pre>
              </td>
              <td>
                <span v-if="!chekcJson(item.NewValue)">{{
                  item.NewValue
                }}</span>
                <pre v-if="chekcJson(item.NewValue)">{{
                  chekcJson(item.NewValue)
                }}</pre>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "@/store";

const store = useStore();
export default {
  name: "ag-audit-detail",
  props: {
    props: {
      data: {
        type: Array,
        default: null,
      },
      options: {
        type: Object,
        default: null,
      },
    },
  },
  components: {},
  data() {
    return {
      tableData: {},
    };
  },
  setup() {
    localStorage.setItem("scopeDetail", "");
    localStorage.setItem("scopeauditDetailData", "");
    return {};
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    selectedRow() {
      if (this.selectedRow && this.selectedRow.auditData) {
        document.getElementById("ag-tab_auditEvent").innerHTML = 'Audit Event : ' + this.selectedRow.auditAction;
        try {
          this.tableData = JSON.parse(this.selectedRow.auditData);
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  methods: {
    chekcJson(data) {
      try {
        return JSON.parse(data);
      } catch (error) {
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
.auditDetail {
  font-size: 15px;
}

.auditDetail .table-responsive > .card {
  padding: 0;
}

.auditDetail .table-responsive select {
  margin: 0 7.5px;
}

.auditDetail .table-responsive div[role="status"] {
  font-size: 13px;
}

.auditDetail
  .table-responsive
  .pagination
  .page-item.disabled:not(:nth-child(1)):not(:nth-child(2)):not(:nth-last-child(1)):not(:nth-last-child(2))
  a {
  background: #4c8dbb;
  color: #fff !important;
}

.auditDetail .table-responsive .pagination .page-item.disabled a:focus,
.auditDetail .table-responsive .pagination .page-item.disabled a:hover {
  box-shadow: none !important;
  outline: none !important;
}
.name-btn {
  display: flex;
  align-items: center;
  i {
    margin-right: 4px;
  }
}
</style>
